<template>
  <div>
    <email-address-table
        ref="table"
        :url="indexUrl"
        :can-create="canCreate"
        :create-url="createUrl"
    ></email-address-table>
    <dialog-form-wrapper></dialog-form-wrapper>
  </div>
</template>

<script>
import DialogFormWrapper from '../dialog-form-wrapper';
import EmailAddressTable from './table';

export default {
  components: {
    DialogFormWrapper,
    EmailAddressTable,
  },

  props: {
    indexUrl: null,
    createUrl: null,
    canCreate: {
      type: Boolean,
      default: false
    },
  },
}
</script>
